import axios from "axios";
import {IOfficer, IOfficerResponse} from "./Officer.types";

export default class OfficerApi {
    static async get({ queryKey }) {
        //eslint-disable-next-line
        const [_key, officerId] = queryKey;
        try {
            let res = await axios.get(`/officers/${officerId}`);
            if (res) {
                return res.data as IOfficer
            }
        } catch (e) {
            console.log('Error getting officers', e.message);
            return undefined;
        }
    }
    static async getOfficers({ queryKey }) {
        //eslint-disable-next-line
        const [_key, params] = queryKey;
        try {
            let res = await axios.post('/officers', params);
            if (res) {
                return res.data as IOfficerResponse
            }
        } catch (e) {
            console.log('Error getting officers', e.message);
            return undefined;
        }
    }
    static async exportOfficers(params) {
        try {
            let res = await axios.post('/officers/export', params);
            if (res) {
                return res.data.records as string[]
            }
        } catch (e) {
            console.log('Error exporting officers', e.message);
            return undefined;
        }
    }
}